import { useFrameZoom } from "../../js/hooks/useFrameZoom";

export default function FrameZoomControls({ label = "Form zoom" }) {
  const { frameZoom, nudgeZoom } = useFrameZoom();

  return (
    <div className="frame-zoom" role="group" aria-label={label} data-tour="frame-zoom">
      <button type="button" className="frame-zoom__btn" onClick={() => nudgeZoom(-0.05)} aria-label="Zoom out">
        −
      </button>
      <span className="frame-zoom__value">{Math.round(frameZoom * 100)}%</span>
      <button type="button" className="frame-zoom__btn" onClick={() => nudgeZoom(0.05)} aria-label="Zoom in">
        +
      </button>
    </div>
  );
}
